export const CSS = {
  container: "container",
  searchIcon: "search-icon",
};

export const ICONS = {
  search: "search",
  close: "x",
};

export const DEBOUNCE_TIMEOUT = 250;
